'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _genericIntent = require('../../generic-intent');

var _feesCalculatorIntent = require('../../../molecules/fees-calculator-intent');

var _feesCalculatorIntent2 = _interopRequireDefault(_feesCalculatorIntent);

var _feesCalculatorContact = require('../../../molecules/fees-calculator-contact');

var _feesCalculatorContact2 = _interopRequireDefault(_feesCalculatorContact);

var _feesCalculatorCalculation = require('../../../molecules/fees-calculator-calculation');

var _feesCalculatorCalculation2 = _interopRequireDefault(_feesCalculatorCalculation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var typeMap = {
  FeesCalculation: _feesCalculatorCalculation2.default,
  FeesContact: _feesCalculatorContact2.default
};

var FeesCalculator = function (_React$Component) {
  _inherits(FeesCalculator, _React$Component);

  function FeesCalculator() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FeesCalculator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FeesCalculator.__proto__ || Object.getPrototypeOf(FeesCalculator)).call.apply(_ref, [this].concat(args))), _this), _this.renderContent = function (content) {
      if (content) {
        return content.map(function (properties, idx) {
          var FeesType = typeMap[properties.config.type] || typeMap.FeesCalculation;
          var key = idx;
          return _react2.default.createElement(FeesType, _extends({ key: key }, properties));
        });
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FeesCalculator, [{
    key: 'render',
    value: function render() {
      var className = this.props.config.className;
      var _props$content = this.props.content,
          content = _props$content.content,
          intent = _props$content.intent;
      var fireTracking = this.props.fireTracking;

      return _react2.default.createElement(
        _genericIntent.GenericIntent,
        { className: className, id: this.props.config.id },
        _react2.default.createElement(
          _genericIntent.Intent,
          null,
          _react2.default.createElement(_feesCalculatorIntent2.default, _extends({ fireTracking: fireTracking }, intent))
        ),
        _react2.default.createElement(
          _genericIntent.Content,
          null,
          this.renderContent(content)
        )
      );
    }
  }]);

  return FeesCalculator;
}(_react2.default.Component);

exports.default = FeesCalculator;


FeesCalculator.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    className: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    intent: _feesCalculatorIntent2.default.propTypes,
    content: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape(_feesCalculatorCalculation2.default.propTypes), _propTypes2.default.shape(_feesCalculatorContact2.default.propTypes)]))
  }),
  fireTracking: _propTypes2.default.func
};
/* eslint-disable max-len */
FeesCalculator.defaultProps = {
  config: {
    id: '',
    className: 'fees-calc'
  },
  content: {
    intent: {
      content: {
        headline: {
          text: 'Estimate your fees'
        },
        subheadline: {
          text: 'If your monthly sales are:'
        },
        items: [{
          text: '< £1,500.00'
        }, {
          text: '£1,500.01 - £6,000.00'
        }, {
          text: '> £6,000.01'
        }]
      }
    },
    content: [{
      config: {
        type: 'FeesCalculation'
      },
      content: {
        headline: {
          text: 'You should pay'
        },
        fees: {
          text: '3.4% + 20p'
        },
        footer: {
          text: 'per transaction'
        },
        hatchText: {
          text: 'See all fees <a href="#">example</a>'
        }
      }
    }, {
      config: {
        type: 'FeesCalculation'
      },
      content: {
        headline: {
          text: 'You should pay'
        },
        fees: {
          text: '2.9% + 20p'
        },
        footer: {
          text: 'per transaction'
        },
        hatchText: {
          text: 'See all fees <a href="#">example</a>'
        }
      }
    }, {
      config: {
        type: 'FeesContact'
      },
      content: {
        fees: {
          text: 'Call 0800 358 7929 for pricing'
        },
        hatchText: {
          text: '34 characters maximum per line'
        },
        legalText: {
          text: 'Freephone from a UK landline. However, charges may apply if you call from a mobile and are dependent on the terms of agreement with your mobile network provider. If you are calling from outside the UK, call 00353 1 436 9004 (international call charges may apply).'
        }
      }
    }]
  },
  fireTracking: function fireTracking() {}
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/fees-calculator/jsx/FeesCalculator.js
// module id = 1090
// module chunks = 4